import React from 'react';
import Navbar from '../components/layout/Navbar';
import SmoothScroll from '../components/common/SmoothScroll';
import HeroSection from '../components/landing/HeroSection';
import MarqueeSection from '../components/landing/MarqueeSection';
import FeatureBento from '../components/landing/FeatureBento';
import ScrollPreview from '../components/landing/ScrollPreview';
import StickyTimeline from '../components/landing/StickyTimeline';
import PricingSection from '../components/landing/PricingSection';
import CTASection from '../components/landing/CTASection';
import Footer from '../components/landing/Footer';

const LandingPage = () => {
    return (
        <SmoothScroll>
            <div className="bg-cyber-black font-rajdhani selection:bg-neon-blue selection:text-black">
                <Navbar />
                <HeroSection />
                <MarqueeSection />
                <FeatureBento />
                <ScrollPreview />
                <StickyTimeline />
                <PricingSection />
                <CTASection />
                <Footer />
            </div>
        </SmoothScroll>
    );
};

export default LandingPage;
